import React from 'react';
import { Text, TouchableRipple, Button, HelperText, Appbar } from 'react-native-paper';
import { router } from 'expo-router';
import { SearchNormal1, User, ArrowRight2 } from 'iconsax-react-native';
import { View, Image, Platform } from 'react-native';
import Logo from '../../assets/logo.png';

export default function AppBar({title = false, leftText = false, isHome = false}) {
  
  return (
    <View style={{ overflow: 'visible', paddingBottom: 0, backgroundColor: '#fcfcfd' }}>
      <View style={{ paddingHorizontal: 18, backgroundColor: '#fff', height: 66, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', elevation: 3 }}>
        <View style={{ width: '70%', flexDirection: 'row', alignItems: 'center' }}>
          {
            isHome ?
              <Image dir="rtl" style={{ width: 76, height: 45, marginRight: Platform.OS === 'web' ? 10 : 0, marginLeft: Platform.OS === 'web' ? 0 : 10 }} source={Logo} />
            :
              <TouchableRipple onPress={() => router.back()} borderless style={{ width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 38, marginRight: Platform.OS === 'web' ? 0 : 8, marginLeft: Platform.OS === 'web' ? 8 : 0 }}><ArrowRight2 size="24" color="#292d32" variant="Outline" /></TouchableRipple>
          }
          {
            title && <Text style={{ fontSize: 16, fontFamily: 'IRANSans_Medium', color: isHome ? '#5b5e63' : '#292D32' }}>{title}</Text>
          }
        </View>
        <View>
          {
            leftText && <Text style={{ fontSize: 12, color: '#2B93F3' }}>{leftText}</Text>
          }
          {
            isHome &&
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <TouchableRipple onPress={() => router.push('/search')} borderless style={{ width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 38, marginRight: Platform.OS === 'web' ? 0 : 10, marginLeft: Platform.OS === 'web' ? 10 : 0 }}><SearchNormal1 size="24" color="#292d32" variant="Outline" /></TouchableRipple>
                <TouchableRipple onPress={() => router.push('/profile')} borderless style={{ width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 38 }}><User size="24" color="#292d32" variant="Outline" /></TouchableRipple>
              </View>
          }
        </View>
      </View>
    </View>
  );
}
